import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { DPAccountService } from './dp-accounts.service';
import { DPAccount } from './dp-account';
import { ActivatedRoute, Params } from '@angular/router';
import { DPCustomer } from './dp-customer';
import { DPCustomerService } from './dp-customer.service';
import { NotificationsService } from 'angular2-notifications';
import { Overlay } from 'ngx-modialog';
import { Modal } from 'ngx-modialog/plugins/bootstrap';
import { DialogRef } from 'ngx-modialog';
import { ToasterService } from 'angular2-toaster/src/toaster.service';



@Component({
    templateUrl: 'dp-accounts-component.html',
    providers: [Modal]

})
export class DPAccountComponent implements OnInit {
    accounts: DPAccount[];
    filteredAccounts: DPAccount[];

    selectedAccount: DPAccount;
    addingAccount = false;
    errorResponse: any;
    navigated = false; // true if navigated here
    customer: DPCustomer;
    dialog: any;
    result: any;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    deleting = false;
    customer_id: any;
    accountViewType = 'View All';

    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };

    constructor(
        private toasterService: ToasterService,

        private router: Router,
        private _service: NotificationsService,
        private accountService: DPAccountService,
        private customerService: DPCustomerService,
        private route: ActivatedRoute,
        public modal: Modal,
        overlay: Overlay,
        vcRef: ViewContainerRef
    ) { }

    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }


    getAccountsByCompanyId(customer_id: number) {
        return this.accountService
            .getAccountsByCompanyId(customer_id)
            .then(res => {
                this.accounts = res.user_accounts;
                this.clickViewType(event);
            }
            )
            .catch(error => {
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                const jsonErrorBody = JSON.parse(error._body);
                this.notificationContent = jsonErrorBody.error.message;
                this.createNotification();
            });
    }

    addCustomer() {
        this.addingAccount = true;
        this.selectedAccount = null;
    }

    deleteAccount(account: DPAccount, event: any) {
        event.stopPropagation();
        this.accountService
            .deleteAccount(account)
            .then(res => {
                this.accounts = this.accounts.filter(u => u !== account);
                this.notificationType = 'success';
                this.notificationTitle = 'Successful';
                this.notificationContent = 'Account : ' + account.account_name + ' is deleted';
                this.createNotification();
                this.deleting = false;

                if (this.selectedAccount === account) { this.selectedAccount = null; }
            })
            .catch(error => {
                this.notificationType = 'error';
                this.notificationTitle = 'Error';
                const jsonErrorBody = JSON.parse(error._body);
                this.notificationContent = jsonErrorBody.error.message;
                this.createNotification();
                this.deleting = false;

            });
    }

    ngOnInit() {
        this.route.params.forEach((params: Params) => {
            this.customer_id = +params['customerId'];
            this.navigated = true;
            localStorage.setItem('customerId', params['customerId']);

        });
        this.customerService.getCustomer(this.customer_id)
            .then(customer => this.customer = customer);
        this.getAccountsByCompanyId(this.customer_id);

    }
    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer']);

        }
    }

    onSelect(account: DPAccount) {
        this.selectedAccount = account;
        this.addingAccount = false;
    }

    gotoDetail(account: DPAccount) {
        this.router.navigate(['/demandportal/customer/account/accountdetail', account.account_id]);
    }

    selectCreateAccount() {
        this.router.navigate(['/demandportal/customer/account/accountcreate', this.customer.customer_id]);
    }

    gotoUserList(account: DPAccount) {
        this.router.navigate(['/demandportal/customer/account/users', account.account_id]);
    }

    gotoSubscriptions(account: DPAccount) {
        this.router.navigate(['/demandportal/customer/account/subscriptions', account.account_id]);
    }

    gotoProjects(account: DPAccount) {
        this.router.navigate(['/demandportal/customer/account/projects', account.account_id]);
    }

    clickViewType(event: any) {
        if (this.accountViewType === 'View All') {
            this.filteredAccounts = this.accounts;
            this.filteredAccounts.sort((leftSide, rightSide): number => {
                if (leftSide.status < rightSide.status) { return 1; };
                if (leftSide.status > rightSide.status) { return -1; };
                if (leftSide.status === rightSide.status && leftSide.account_id > rightSide.account_id) { return -1; };
                if (leftSide.status === rightSide.status && leftSide.account_id < rightSide.account_id) { return 1; };
                return 0;
            });
        } else if (this.accountViewType === 'View Active') {
            this.filteredAccounts = this.accounts.filter(c => c.status === 1);
        } else {
            this.filteredAccounts = this.accounts.filter(c => c.status === 0);
        }
    }




    onClickActivationAccount(account: DPAccount, event: any) {
        event.stopPropagation();
        let dialogMessage = '';
        if (account.status === 1) {
            dialogMessage = 'You really want to deactivate this account?';
        } else {
            dialogMessage = 'You really want to activate this account?';
        }
        this.deleting = true;
        this.dialog = this.modal.confirm()
            .size('sm')
            .isBlocking(false)
            .showClose(false)
            .keyboard(27)
            .body(dialogMessage)
            .okBtn('Yes')
            .cancelBtn('No')
            .open();
        this.processDialogActivation(account, event, this.dialog);
    }
    private processDialogActivation(account: DPAccount, event: any, dialog: Promise<DialogRef<any>>) {
        dialog.then((resultPromise) => {
            return resultPromise.result.then((result) => {
                if (account.status === 1) {
                    account.status = 0;
                } else {
                    account.status = 1;
                }
                this.save(account);
            }, () => {
                this.deleting = false;
                this.result = 'Rejected!';
            });
        });
    }

    save(account: DPAccount) {
        this.accountService
            .updateAccount(account)
            .then(res => {
                this.deleting = false;
                this.getAccountsByCompanyId(this.customer_id);
            }
            )
            .catch(error => {
                if (account.status === 1) {
                    account.status = 0;
                } else {
                    account.status = 1;
                }
                this.deleting = false;
                this.notificationType = 'error';
                this.notificationTitle = 'error';
                const jsonErrorBody = JSON.parse(error._body);
                this.notificationContent = jsonErrorBody.error.message;
                this.createNotification();
            });
    }

}




// WEBPACK FOOTER //
// ./src/app/portalv1/dp-accounts-component.ts